import { render } from "./TransactionsEmpty.vue?vue&type=template&id=161ab230&scoped=true&ts=true"
import script from "./TransactionsEmpty.vue?vue&type=script&lang=ts"
export * from "./TransactionsEmpty.vue?vue&type=script&lang=ts"

import "./TransactionsEmpty.vue?vue&type=style&index=0&id=161ab230&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161ab230"]])

export default __exports__